import React, { type ReactElement } from 'react';

interface IconTrustpilotProps {
  width?: number;
  height?: number;
  className?: string;
}

export function IconTrustpilot({
  width = 19,
  height = 18,
  className,
}: IconTrustpilotProps): ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 19 18"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3335 7.24634L11.4567 7.24634L9.33976 0.749999L7.21032 7.24634L0.333497 7.23389L5.89508 11.2537L3.76565 17.75L9.32723 13.7302L14.8888 17.75L12.7719 11.2537L18.3335 7.24634Z"
        fill="#00B67A"
      />
    </svg>
  );
}
